export enum SortingTypesEnums {
  ASCEND = 'ascend',
  DESCEND = 'descend',
}
